/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef, useState } from 'react';
import { PropTypes, describe } from '@elliemae/ds-props-helpers';
import { DSMobileContextMenu, DSMobileContextMenuItem } from '../MobileContextMenu/index.js';
import { DSMobileDropdownTriggerInput } from './MobileDropdownInput.js';
interface OptionT {
  label: string;
  value: string;
}
interface DSMobileDropdownMenuPropsT {
  placeholder: string;
  value: string;
  options: OptionT[];
  title: string;
  itemsProps: {
    label?: string;
    leftProp?: JSX.Element;
    isGroup?: boolean;
    isMulti?: boolean;
    singleSelect?: boolean;
    isItemSelected?: (opt: OptionT) => boolean;
    onClick?: (opt: OptionT, e: any) => void;
  };
}
const DSMobileDropdownMenu = ({
  placeholder,
  options = [],
  title,
  value,
  itemsProps = {
    label: undefined,
    leftProp: undefined,
    isGroup: false,
    isMulti: false,
    singleSelect: false,
    isItemSelected: () => false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClick: () => {},
  },
}: DSMobileDropdownMenuPropsT): JSX.Element => {
  const [menuOpen, setMenuOpen] = useState(false);
  const inputRef = useRef(null);
  const inputProps = React.useMemo(
    () => ({
      readOnly: true,
      value,
      onClick: () => setMenuOpen(true),
      innerRef: inputRef,
      placeholder,
    }),
    [value, placeholder],
  );
  const caretProps = React.useMemo(
    () => ({
      onClick: () => {
        inputRef.current.focus();
        setMenuOpen(true);
      },
    }),
    [],
  );
  return (
    <>
      <DSMobileDropdownTriggerInput inputProps={inputProps} caretProps={caretProps} />
      {menuOpen ? (
        <DSMobileContextMenu
          title={title}
          open
          onChange={(_, e) => {
            setMenuOpen(false);
          }}
          onClickOutside={() => setMenuOpen(false)}
        >
          {options.map((opt, i) => (
            <DSMobileContextMenuItem
              key={'ddwn'.concat(`${i}`)}
              title={opt.label}
              value={opt.value}
              isSelected={itemsProps.isItemSelected(opt)}
              onClick={(e) => {
                setMenuOpen(false);
                itemsProps.onClick(opt, e);
              }}
              label={itemsProps.label}
              leftProp={itemsProps.leftProp}
              isGroup={itemsProps.isGroup}
              isMulti={itemsProps.isMulti}
              singleSelect={itemsProps.singleSelect}
            />
          ))}
        </DSMobileContextMenu>
      ) : null}
    </>
  );
};

const props = {
  /** dropdown menu placeholder */
  placeholder: PropTypes.string.description('dropdown menu placeholder'),
  /** context menu menu title */
  title: PropTypes.string.description('context menu menu title'),
  /** context menu options / items */
  options: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.string, label: PropTypes.string })).description(
    'context menu options / items',
  ),
};

DSMobileDropdownMenu.displayName = 'DSMobileDropdownMenu';
const DSMobileDropdownMenuWithSchema = describe(DSMobileDropdownMenu);
DSMobileDropdownMenuWithSchema.propTypes = props;

export { DSMobileDropdownMenu, DSMobileDropdownMenuWithSchema };
